import * as React from "react";
function SvgChevronLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        d="M23 2L9 16l14 14"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgChevronLeft);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
